import Vue from 'vue'
import Router  from 'vue-router'
import payment from './../components/payment'
import finishSuccess from './../components/finishSuccess'
import finishError from './../components/finishError'
import finishAwait from "../components/finishAwait";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      redirect: { name: 'payment' }
    },
    {
      name: 'payment',
      path: '/payment',
      component: payment
    },
    {
      path: '/success',
      component: finishSuccess
    },
    {
      path: '/await',
      component: finishAwait
    },
    {
      path: '/error',
      component: finishError
    },
    {
      path: '*',
      redirect: { name: 'payment' },
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js